import "./QuickActions.css";

import { useNavigate } from "react-router-dom";

import {
  MdAddCircleOutline,
  MdShoppingBag,
  MdPerson,
  MdAnalytics,
  MdBakeryDining,
  MdRestaurantMenu,
  MdCelebration,
  MdLocalGroceryStore,
} from "react-icons/md";

function QuickActions({ provider }) {
  const navigate = useNavigate();

  const providerType = provider?.providerType;

  const getManagementAction = () => {
    switch (providerType) {
      case "Bakery":
        return {
          title: "Add Product",
          icon: <MdBakeryDining />,
          path: "/business/my-bakery",
          color: "#ff6b35",
        };

      case "Restaurant":
        return {
          title: "Add Menu",
          icon: <MdRestaurantMenu />,
          path: "/business/my-foods",
          color: "#ff6b35",
        };

      case "Hotel":
        return {
          title: "Add Menu",
          icon: <MdRestaurantMenu />,
          path: "/business/my-foods",
          color: "#ff6b35",
        };

      case "Catering":
        return {
          title: "Add Package",
          icon: <MdCelebration />,
          path: "/business/my-catering",
          color: "#ff6b35",
        };

      case "Provision Store":
        return {
          title: "Add Item",
          icon: <MdLocalGroceryStore />,
          path: "/business/my-provision",
          color: "#ff6b35",
        };

      default:
        return {
          title: "Add Food",
          icon: <MdAddCircleOutline />,
          path: "/business/my-foods",
          color: "#ff6b35",
        };
    }
  };

  const actions = [
    getManagementAction(),

    {
      title: "Orders",
      icon: <MdShoppingBag />,
      path: "/business/orders",
      color: "#2563eb",
    },

    {
      title: "Profile",
      icon: <MdPerson />,
      path: "/business/profile",
      color: "#16a34a",
    },

    {
      title: "Analytics",
      icon: <MdAnalytics />,
      path: "/business/analytics",
      color: "#9333ea",
    },
  ];

  return (
    <div className="quick-actions-card">
      <div className="quick-header">
        <h2>Quick Actions</h2>

        <p>Frequently used shortcuts</p>
      </div>

      <div className="quick-grid">
        {actions.map((action, index) => (
          <button
            key={index}
            className="quick-btn"
            onClick={() => navigate(action.path)}
          >
            <div
              className="quick-icon"
              style={{
                background: action.color,
              }}
            >
              {action.icon}
            </div>

            <span>{action.title}</span>
          </button>
        ))}
      </div>
    </div>
  );
}

export default QuickActions;